// const $window = $(window);
// let windowWidth = $window.width();

// // メディアクエリ
// let mql = window.matchMedia('screen and (max-width: 1024px)');

//preload
import {preload} from "../include/module";
preload();

// toggleHeader
import {toggleHeader} from "../include/module";
toggleHeader();

//pageTop
import {pageTop} from "../include/module";
pageTop();

//showMovie
import {showMovie} from "../include/module";
showMovie();

//showAbout
import {showAbout} from "../include/module";
showAbout();

//anchorLink
import {anchorLink} from "../include/module";
anchorLink();


$(window).on('load' , function() {

  // setTimeout(function(){$('#st-Loader .st-Loader_Logo').addClass("load");},400);
  // setTimeout(function(){$('#st-Loader').addClass("hidden");},1200);
  // setTimeout(function(){$('#st-Loader').remove();},1600);

  // setTimeout(function(){$('.js-loadingAnimation').addClass("is-animated");},1600);

  scrollIndexAnime();
  toggleChara();

});



// ------------------------------------------------------------------------
// scrollIndexAnime
// ----- BOTH
// ------------------------------------------------------------------------
const scrollIndexAnime = () => {

  const controller = new ScrollMagic.Controller();

  //ページトップ出現
  const scene = new ScrollMagic.Scene({
    triggerElement:'.index-Story',
    triggerHook: 1,
    offset: '80'
  })
  .setClassToggle('#st-Top', 'st-Top-Show')
  .addTo(controller);

  //アプリ誘導
  const scene2 = new ScrollMagic.Scene({
    triggerElement:'.index-Story',
    triggerHook: 1,
    offset: '80'
  })
  .setClassToggle('#following', 'show')
  .addTo(controller);

  //アプリ誘導
  const scene3 = new ScrollMagic.Scene({
    triggerElement:'.st-Footer',
    triggerHook: 1,
    offset: '80'
  })
  .setClassToggle('#following, #st-Top', 'hidden')
  .addTo(controller);

  // //　スクロールで発火系
  // const targets = document.querySelectorAll(".js-scrollAnimation");
  // const targetsArray = Array.prototype.slice.call(targets); //Array
  // targetsArray.forEach(target => {
  //   //シーンを作成
  //   const scene3 = new ScrollMagic.Scene({
  //       triggerElement: target,
  //       triggerHook: .8
  //   })
  //   .setClassToggle(target, "is-animated")
  //   .addTo(controller);
  // });

};

// ------------------------------------------------------------------------
// toggleChara
// ----- BOTH
// ------------------------------------------------------------------------
const toggleChara = () => {

  // こころ
  var charaSwiper0;
  charaSwiper0 = new Swiper('.illust-slide-kokoro', {
    initialSlide: 0, // 0で特訓前 1で特訓後
    effect: 'flip',
    grabCursor: true,
    speed: 600,
    loop: true,
    pagination: {
      el: '.slide-pagination-kokoro',
      clickable: true,
    },
    allowTouchMove: true,
  });

  // 薫
  var charaSwiper1;
  charaSwiper1 = new Swiper('.illust-slide-kaoru', {
    initialSlide: 1, // 0で特訓前 1で特訓後
    effect: 'flip',
    grabCursor: true,
    speed: 600,
    loop: true,
    pagination: {
      el: '.slide-pagination-kaoru',
      clickable: true,
    },
    allowTouchMove: true,
  });

  // はぐみ
  var charaSwiper2;
  charaSwiper2 = new Swiper('.illust-slide-hagumi', {
    initialSlide: 0, // 0で特訓前 1で特訓後
    effect: 'flip',
    grabCursor: true,
    speed: 600,
    loop: true,
    pagination: {
      el: '.slide-pagination-hagumi',
      clickable: true,
    },
    allowTouchMove: true,
  });

  // 花音
  var charaSwiper3;
  charaSwiper3 = new Swiper('.illust-slide-kanon', {
    initialSlide: 0, // 0で特訓前 1で特訓後
    effect: 'flip',
    grabCursor: true,
    speed: 600,
    loop: true,
    pagination: {
      el: '.slide-pagination-kanon',
      clickable: true,
    },
    allowTouchMove: true,
  });

  // 美咲
  var charaSwiper4;
  charaSwiper4 = new Swiper('.illust-slide-misaki', {
    initialSlide: 0, // 0で特訓前 1で特訓後
    effect: 'flip',
    grabCursor: true,
    speed: 600,
    loop: true,
    pagination: {
      el: '.slide-pagination-misaki',
      clickable: true,
    },
    allowTouchMove: true,
  });

}



// WEBPACK FOOTER //
// ./src/assets/js/index/script.js